document.body.addEventListener('click', function (event) {
    const button = event.target.closest('button[data-action]');
    if (!button) return;

    const input = document.getElementById('updates_' + button.dataset.key);

    if (!input) {
        console.error('No matching input field found');
        return;
    }

    let value = parseInt(input.value, 10);

    if (isNaN(value)) {
        console.error('Invalid input value');
        return;
    }

    if (button.dataset.action === 'decrement') {
        value--;
    } else if (button.dataset.action === 'increment') {
        value++;
    }

    if (value > 0) {
        input.value = value;
        input.form.submit();
    }
});
